export default __webpack_public_path__ + "static/media/waffle9.f6450714.png";